export default [{
    path: 'support',
    name: 'Support',
    component: () =>
        import ('../../../views/Support.vue'),
    meta: { title: 'Support',permission:'show_all_support' }
}]
